import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getUserById } from '../thunk/getUserById';

interface IUser {
  id: string | number;
  name: string;
  email?: string;
}

interface IUsersRes {
  items: IUser[],
  totalCount: number,
}

export interface initialState {
  userById: any,
  userByIdLoading: boolean,
  userByIdError: any,
  usersLookup: IUsersRes;
  usersLookupLoading: boolean;
  usersLookupError: any;
}

const initialState: initialState = {
  userById: null,
  userByIdLoading: false,
  userByIdError: null,
  usersLookup: {
    items: [],
    totalCount: 0,
  },
  usersLookupLoading: false,
  usersLookupError: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {

  },
  extraReducers: builder => {
    builder
      .addCase(getUserById.pending, (state) => {
        state.userByIdLoading = true;
        state.userByIdError = null;
      })
      .addCase(getUserById.fulfilled, (state, action: PayloadAction<any>) => {
        state.userByIdLoading = false;
        state.userById = action.payload;
        state.userByIdError = null;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.userByIdLoading = false;
        state.userByIdError = action.error.message || 'Неизвестная ошибка';
      });
  }
});

// export const { addUser, removeUser } = usersSlice.actions;

export default usersSlice.reducer;
